import React, { FunctionComponent } from 'react';
import Col from 'antd/lib/grid/col';
import ComponentLink from '@/components/navigation/ComponentLink';
import { orderBy } from 'lodash';
import styles from './LandingPageLinkIndex.module.scss';

interface IProps {
  links: { title: string; url: string }[];
}

const LinkColumns: FunctionComponent<IProps> = ({ links = [] }) => {
  const chunkIntoN = (arr, n) => {
    const size = Math.ceil(arr.length / n);
    return Array.from({ length: n }, (v, i) => arr.slice(i * size, i * size + size));
  };
  const sortedLinks = orderBy(links, ['title'], ['asc']);
  const chunkedLists = chunkIntoN(sortedLinks, 3);
  return (
    <>
      {chunkedLists.map((list) => (
        <Col xs={24} sm={12} md={8} lg={8} xl={8} className={styles.textLeft} key={`chunk-row-${list[0]?.title}`}>
          {list.map((item) => (
            <div key={`slug-thing-${item.title}`}>
              <ComponentLink href={item.url} style={{ fontSize: 16 }}>
                {item.title}
              </ComponentLink>
            </div>
          ))}
        </Col>
      ))}
    </>
  );
};

export default LinkColumns;
